import { GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';

async function trackVoucherInfoClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'IconClick',
        label: 'Info_BuyVoucher',
    });
}

async function trackTicketInfoClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'IconClick',
        label: 'Info_BookAppointment',
    });
}

async function trackBuyVoucherClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'ButtonClick',
        label: 'BuyVoucher',
        eventData: {
            eventName: GA4EventName.SelectProductVariant,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            selected_value: 'Experience voucher',
        },
    });
}

async function trackBuyTicketClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'ButtonClick',
        label: 'BookAppointment',
        eventData: {
            eventName: GA4EventName.SelectProductVariant,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            selected_value: 'Experience ticket',
        },
    });
}

export {
    trackBuyTicketClicked,
    trackBuyVoucherClicked,
    trackTicketInfoClicked,
    trackVoucherInfoClicked,
};
